import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { DF_OT0050Context } from "../context";

function GridHeader() {
  const { isModalPage } = useSelector((state) => ({
    isModalPage: state.Layout.isModalPage,
  }));

  const {
    isLoading,
    setTriggerOnFilter,
    setParamsOnFilter,
    setIsOpenModalNuevo,
    userProfile,
  } = useContext(DF_OT0050Context);

  const [preFilter, setPreFilter] = useState([{}]);

  useEffect(() => {
    setTriggerOnFilter(true);
  }, [setTriggerOnFilter]);

  const onSubmitFilter = () => {
    setParamsOnFilter([...preFilter]);
    setTriggerOnFilter(true);
  };

  const idEmpresaSelecionada = preFilter?.[0]?.Filtro_ID_Empresa?.value ?? null;

  const handleNovo = () => {
    if (!idEmpresaSelecionada) {
      alert(
        "Selecione uma empresa antes de cadastrar um novo local de entrega.",
      );
      return;
    }
    setIsOpenModalNuevo(true);
  };

  if (isModalPage) return <></>;

  return (
    <React.Fragment>
      <Row className="mb-2">
        <Col lg={12} className={isLoading ? "disabled" : ""}>
          <h4 className="m-0 mb-3 font-w-600 font-size-24 text-color-azul1">
            Gestão de Locais de Entrega
          </h4>

          <div className="bg-white mb-3 card-content shadow-card p-4">
            <div className="row align-items-end gx-3">
              <div className="col-lg-5 col-md-12">
                <TranspaleStringToComponente
                  elementId={"ID_Empresa"}
                  elementProps={{
                    value: "",
                    type: "Combobox",
                    title: "Empresa",
                    id: "Filtro_ID_Empresa",
                    isDisabled: false,
                    procedure: "SRM_Agendamento_Get_Empresas",
                    procedureParams: [userProfile?.ID_Usuario],
                  }}
                  preFilter={preFilter}
                  onPreFilter={(filters) => {
                    setPreFilter((state) => [{ ...state[0], ...filters }]);
                  }}
                />
              </div>

              <div className="col-lg-5 d-none d-lg-block"></div>

              <div className="col-lg-2 col-md-12">
                <div className="d-flex justify-content-end align-items-end gap-2 h-100 pb-3">
                  <button
                    type="button"
                    className="btn btn-primary-dark text-white fw-semibold"
                    onClick={onSubmitFilter}
                  >
                    Pesquisar
                  </button>

                  <button
                    type="button"
                    className={`btn btn-primary-dark text-white fw-semibold ${
                      !idEmpresaSelecionada ? "btn-acao-disabled" : ""
                    }`}
                    onClick={handleNovo}
                    title={
                      !idEmpresaSelecionada
                        ? "Selecione uma empresa primeiro"
                        : ""
                    }
                  >
                    Novo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

export default GridHeader;
